import React from 'react';
import { Helmet } from 'react-helmet-async';
import { getAppTitle, getSiteUrl } from '../utils/config';
import { SeoMeta } from '../config/seoPages';

interface SeoHeadProps {
  meta: SeoMeta;
}

export const SeoHead: React.FC<SeoHeadProps> = ({ meta }) => {
  const siteUrl = getSiteUrl();
  const canonical = `${siteUrl}${meta.path}`;
  const alternate = meta.alternatePath ? `${siteUrl}${meta.alternatePath}` : undefined;
  const ogLocale = meta.locale === 'zh' ? 'zh_CN' : 'en_US';
  const alternateLocale = meta.locale === 'zh' ? 'en_US' : 'zh_CN';

  return (
    <Helmet htmlAttributes={{ lang: meta.locale === 'zh' ? 'zh-CN' : 'en' }}>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta name="keywords" content={meta.keywords.join(', ')} />
      {meta.noindex ? (
        <meta name="robots" content="noindex, follow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      <link rel="canonical" href={canonical} />
      {alternate && (
        <>
          <link rel="alternate" hrefLang={meta.locale === 'zh' ? 'zh-CN' : 'en'} href={canonical} />
          <link rel="alternate" hrefLang={meta.locale === 'zh' ? 'en' : 'zh-CN'} href={alternate} />
          <link rel="alternate" hrefLang="x-default" href={meta.locale === 'zh' ? canonical : alternate} />
        </>
      )}
      <meta property="og:site_name" content={getAppTitle()} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content={ogLocale} />
      {alternate && <meta property="og:locale:alternate" content={alternateLocale} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
    </Helmet>
  );
};
